import { HttpInterceptorService } from "admin/src/app/shared/services/http-interceptor.service";
import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { LogBookService } from "./logbook.service";
import { AuthClientService } from "../../authentication/auth-client.service";
import { AppStateService } from "./app-state.service";
import { LogoutService } from "app/authentication/logout.service";

@Injectable({
    providedIn: 'root'
})
export class HttpInterceptorClientService extends HttpInterceptorService {
    protected get authService(): AuthClientService {
        return this.injector.get(AuthClientService);
    }

    protected get appState(): AppStateService {
        return this.injector.get(AppStateService);
    }

    protected get logBookService(): LogBookService {
        return this.injector.get(LogBookService);
    }
    
    protected get logoutService(): LogoutService {
        return this.injector.get('logoutService');
    }

    onSuccess(response: HttpResponse<any>) {
        const apiVer = response.headers.get('X-LogBook-Api-Version');
        if (apiVer)
        {
            this.logBookService.LOGBOOK_API_VERSION = apiVer;
        }
        this.logoutService.extendSession();
    }

	onError(error: HttpErrorResponse): void {
		switch (error.status) {
			case 401:
				this.authService.onUnauthenticated(error);
				break;
			case 502: // Bad Gateway
			case 504: // Gateway Timeout
			case 503:
				if (error.headers.get('content-type') == 'text/html') {
					const body = error.error;
					if (typeof body == 'string') {
						try {
							const resDocBody = new DOMParser().parseFromString(body, 'text/html');
							const isMaintenancePage = resDocBody.getElementsByTagName('meta').namedItem('logbook-maintenance-page') != null;
							if (isMaintenancePage) {
								window.location.reload();
							}
						}
						catch (e) {
							console.debug(`Found non-parseable HTML from response ${body}`);
						}
					}
				}
				if (error.error?.maintenanceInfo)
					this.appState.updateMaintenanceMode(error.error);
				break;
		}
    }
}